<template>
  <div>
    <b-card>
      <b-row>
        <b-col cols="12">
          <service-types />
        </b-col>
        <b-col cols="12">
          <service-statuses />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <start-date />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <end-date />
        </b-col>
        <b-col cols="12">
          <notes-text />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import ServiceTypes from '@/views/Services/Elements/ServiceTypes.vue'
import ServiceStatuses from '@/views/Services/Elements/ServiceStatuses.vue'
import StartDate from '@/views/Services/Elements/StartDate.vue'
import EndDate from '@/views/Services/Elements/EndDate.vue'
import NotesText from '@/views/Services/Elements/NotesText.vue'

export default {
  name: 'ItemForm',
  components: {
    ServiceTypes,
    ServiceStatuses,
    StartDate,
    EndDate,
    NotesText,
    BCard,
    BRow,
    BCol,
  },
  computed: {
    dataItem() {
      return this.$store.getters['workers/dataItem']
    },
  },
}
</script>
